import React from "react";
import {
  DEBI_REPORT_STATUS_LIST,
  REPORT_STATUS_LIST,
} from "../../utils/constants/GlobalFormConstants";
import {
  COOKIE_KEY,
  DEBI_RAW_DATA,
  DECRYPT_KEY,
  EXPORT_LABEL,
  FROM_LABEL,
  MT_25,
  PART_SALES_SUM,
  REPORT,
  REPORT_STYLE,
  SELECT_REPORT_TEXT,
  SELECT_STATUS_TEXT,
  DEBI_REQUEST,
  SELECT_DC_TEXT,
  TO_LABEL,
} from "../../utils/constants/GlobalConstants";
import Container from "../common/container/Container";
import GridContainer from "../common/grid/GridContainer";
import GridItem from "../common/grid/GridItem";
import SelectView from "../common/selectView/SelectView";
import ButtonLayout from "../common/button/ButtonLayout";
import { excelReport, excelReportDebiRaw } from "../../services/reportServices";
import SimpleSnackbar from "../common/snackbar/Snackbar";
import SimpleBackdrop from "../common/backdrop/Backdrop";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { getDCList } from "../../services/DCServices";
import { Checkbox } from "@mui/material";
const style = {
  textAlign: "center",
  margintop: "13px",
};
const Report = () => {
  const [reportSelected, setReportSelected] = React.useState();
  const [loader, setLoader] = React.useState(false);
  const [apiError, setApiError] = React.useState({ val: false, messages: "" });
  const [username, setUsername] = React.useState("");
  const [showDateRange, setShowDateRange] = React.useState(false);
  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setToDate] = React.useState(null);
  const [btnDisable, setBtnDisable] = React.useState(true);
  const [selectedStatus, setSelectedStatus] = React.useState("");
  const [rowsDC, setRowsDC] = React.useState([]);
  const [selectedDCs, setSelectedDcs] = React.useState();
  const encryptF = Cookies.get(COOKIE_KEY);
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    if(event.target.checked){
      setSelectedDcs("");
    }

  };
  React.useEffect(() => {
    if (encryptF) {
      const bytes = CryptoJS.AES.decrypt(encryptF, DECRYPT_KEY);
      const decryptData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      decryptData && setUsername(`Hello ${decryptData.given_name}`);
    }
  }, [encryptF]);

  const downloadFile = (response, type, fileName, fileType) => {
    const pdfBlob = new Blob([response], { type: type });
    const url = window.URL.createObjectURL(pdfBlob);
    const tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.download = `${fileName}.${fileType}`;
    tempLink.click();
    window.URL.revokeObjectURL(url);
  };

  const fetchExcel = async () => {
    setLoader(true);
    try {
      if (reportSelected === DEBI_RAW_DATA) {
        let allDc;
        if(checked){
          allDc=rowsDC.map((itm)=>itm.distributionCenterName);
        } else{
          allDc=selectedDCs;
        }
        const response = await excelReportDebiRaw(
          REPORT.DEBI_REGISTRATION,
          selectedStatus,
          fromDate,
          toDate,
          allDc
        );
        downloadFile(
          response,
          "application/vnd.ms-excel",
          `${reportSelected} Report`,
          ".xlsx"
        );
      } else {
        const response = await excelReport(REPORT.PART_SALES_SUMMARY);
        downloadFile(
          response,
          "application/vnd.ms-excel",
          `${reportSelected} Report`,
          ".xlsx"
        );
      }

      setLoader(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };

  const getValue = (item) => {
    switch (item) {
      case DEBI_REQUEST.INCOMPLETE:
        return "Incomplete";
      case DEBI_REQUEST.PENDING:
        return "Pending";
      case DEBI_REQUEST.OPEN:
        return "Open";
      case DEBI_REQUEST.CANCELLED:
        return "Closed";
      default:
        return "Incomplete";
    }
  };
  const DCList = async () => {
    try {
      const response = await getDCList();
      setRowsDC(response?.distributionCenters);

      setLoader(false);
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false);
    }
  };
  return (
    <>
      <SimpleBackdrop open={loader} messageShow={true} />
      <Container title={username}>
        <GridContainer spacing={2}>
          <GridItem xs={12} sm={12} lg={4} md={4} xl={4}></GridItem>
          <GridItem xs={12} sm={12} lg={4} md={4} xl={4}>
            <SelectView
              data={REPORT_STATUS_LIST}
              label={SELECT_REPORT_TEXT}
              testid="selectReport"
              valSelectedFromDropDown={(val) => {
                setReportSelected(val);
                setFromDate(null);
                setToDate(null);
                if (val === DEBI_RAW_DATA) {
                  DCList();
                  setShowDateRange(true);
                  setBtnDisable(true);
                } else {
                  setShowDateRange(false);
                  setBtnDisable(false);
                }
              }}
            />
            {reportSelected && (
              <div style={REPORT_STYLE}>
                {reportSelected === PART_SALES_SUM
                  ? REPORT.PART_SALES_SUMMARY_MSG
                  : reportSelected === DEBI_RAW_DATA
                  ? REPORT.DEBI_RAW_MSG
                  : REPORT.TOP_MSG}
              </div>
            )}
          </GridItem>
        </GridContainer>
        {reportSelected === DEBI_RAW_DATA && (
          <>
            <GridContainer>
              <GridItem xs={12} sm={12} lg={4} md={4} xl={4}></GridItem>
              <GridItem xs={12} sm={12} lg={4} md={4} xl={4}>
                <SelectView
                  data={DEBI_REPORT_STATUS_LIST}
                  label={SELECT_STATUS_TEXT}
                  testid="selectStatus"
                  valSelectedFromDropDown={(val) => {
                    let status = getValue(val);
                    setSelectedStatus(status);
                  }}
                />
              </GridItem>
            </GridContainer>
            {/* <br /> */}
            <GridContainer>
              <GridItem xs={12} sm={12} lg={4} md={4} xl={4}></GridItem>
              <GridItem xs={12} sm={12} lg={4} md={4} xl={4}>
                <Checkbox
                  checked={checked}
                  onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />{" "}
                All DCs
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} lg={4} md={4} xl={4}></GridItem>
              <GridItem xs={12} sm={12} lg={4} md={4} xl={4}>
                <SelectView
                 disabled={checked}
                  data={rowsDC}
                  label={SELECT_DC_TEXT}
                  testid="selectDC"
                  valSelectedFromDropDown={(val) => {
                    setSelectedDcs(val);
                  }}
                  hasMultiple={true}
                />
              </GridItem>
            </GridContainer>
            <br />
          </>
        )}
        {showDateRange && (
          <>
            <GridContainer>
              <GridItem xs={12} sm={12} lg={4} md={4} xl={4}></GridItem>
              <GridItem xs={12} sm={12} lg={4} md={4} xl={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateField", "DatePicker"]}>
                    <DatePicker
                      testid="datecreated"
                      label={FROM_LABEL}
                      disableFuture={true}
                      value={dayjs(fromDate)}
                      onChange={(newValue) => {
                        const dateObject = new Date(newValue.$d);
                        let formattedDate =
                          dateObject.toLocaleDateString("en-CA");
                        let fromDate = formattedDate + "T00:00:00";
                        setFromDate(fromDate);
                        // if (reportSelected === DEBI_RAW_DATA) {
                        //   selectedStatus && newValue?.$d && setBtnDisable(false);
                        // }
                      }}
                      slotProps={{
                        textField: {
                          error: false,
                          fullWidth: true,
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </GridItem>
            </GridContainer>
            <br />
            <GridContainer>
              <GridItem xs={12} sm={12} lg={4} md={4} xl={4}></GridItem>
              <GridItem xs={12} sm={12} lg={4} md={4} xl={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateField", "DatePicker"]}>
                    <DatePicker
                      testid="datecreated1"
                      label={TO_LABEL}
                      disableFuture={true}
                      value={dayjs(toDate)}
                      onChange={(newValue) => {
                        const dateObject = new Date(newValue.$d);
                        let formattedDate =
                          dateObject.toLocaleDateString("en-CA");
                        let fromDate1 = formattedDate + "T00:00:00";
                        setToDate(fromDate1);
                        if (reportSelected === DEBI_RAW_DATA) {
                          if (fromDate1 < fromDate) {
                            setApiError((val) => ({
                              ...val,
                              val: true,
                              message:
                                "End Date cannot be less than Start Date",
                            }));
                            setBtnDisable(true);
                          } else {
                            selectedStatus &&
                              newValue?.$d &&
                              setBtnDisable(false);
                          }
                        }
                      }}
                      slotProps={{
                        textField: {
                          error: false,
                          fullWidth: true,
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </GridItem>
            </GridContainer>
          </>
        )}

        <GridContainer spacing={2}>
          <GridItem xs={12} sm={12} lg={4} md={4} xl={4}></GridItem>
          <GridItem xs={12} sm={12} lg={4} md={4} xl={4}>
            <div style={style}>
              <br />
              <ButtonLayout
                label={EXPORT_LABEL}
                onClickBtn={fetchExcel}
                disabled={btnDisable}
                testid="export"
              />
            </div>
          </GridItem>
        </GridContainer>
        <div className=" border-bt" style={MT_25}></div>
      </Container>

      <SimpleSnackbar apiError={apiError} />
    </>
  );
};

export default Report;
